// Per-browser conveniences (names, packs, switches). Private windows and
// blocked storage just start fresh every time.

export function load<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(`sgb20.${key}`);
    return raw == null ? fallback : { ...fallback, ...JSON.parse(raw) };
  } catch {
    return fallback;
  }
}

export function loadRaw(key: string): string | null {
  try {
    return localStorage.getItem(`sgb20.${key}`);
  } catch {
    return null;
  }
}

export function save(key: string, value: unknown): void {
  try {
    localStorage.setItem(`sgb20.${key}`, typeof value === 'string' ? value : JSON.stringify(value));
  } catch {
    // ignore
  }
}

/// A random id for this browser: the key for purchases, never personal.
export function playerId(): string {
  let id = loadRaw('pid');
  if (!id || !/^[a-zA-Z0-9-]{8,64}$/.test(id)) {
    id = crypto.randomUUID();
    save('pid', id);
  }
  return id;
}
